
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Fribourg durant la deuxième vague`}</h2>
    <p>{`Le fait que la Suisse romande ait été plus largement touchée que les cantons alémaniques a fait l'objet d'un débat public. Pour l'expliquer, les experts s'appuient principalement sur des raisons culturelles. En revanche, le comportement de mobilité, qui ne diffère guère entre les différentes parties du pays, ne joue aucun rôle même s'il s'agit d'un indicateur fiable.`}</p>
    <p>{`Le canton de Fribourg illustre bien ces divergences quasi inexplicables: les communes francophones situées à l'ouest du Röstigraben sont presque toujours plus touchées que les communes germanophones.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;